import Guard from './service/middleware'


export default [

    // Site
    { path: '/site', name: 'home', component: require('./pages/home.vue').default },
    { path: '/site/quemsomos', name: 'quemsomos', component: require('./pages/quemsomos.vue').default },
    { path: '/site/testemapa', name: 'testemapa', component: require('./pages/testemapa.vue').default },
    { path: '/site/testemapa2', name: 'testemapa2', component: require('./pages/testemapa2.vue').default },
    { path: '/site/testemapa3', name: 'testemapa3', component: require('./pages/testemapa3.vue').default },
    { path: '/menu', name: 'cardapio', component: require('./pages/cardapio.vue').default },

    {
        path: '/site/perfil',
        name: 'perfil',
        component: require('./pages/perfil.vue').default,
        beforeEnter: Guard.auth
    },
    {
        path: '/site/pedidos',
        name: 'pedidos',
        component: require('./pages/pedidos.vue').default,
        beforeEnter: Guard.auth
    },

    { path: '*', component: require('./pages/home.vue').default },

];




